import * as types from './actionTypes';
import { ORIGINATIONS_APP_BASE_URL } from '../constants/global';
import {generateURL} from '../api/urlHelper';
import { authenticatedFetch } from '@forwardfinancing/component-library';

export function receiveLatestContracts(json) {
  return {type: types.RECEIVE_LATEST_CONTRACTS, latestContracts: json.applications};
}

export function fetchLatestContracts(params) {
  return dispatch => {
    return authenticatedFetch(latestContractsURL(params), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(json => {
      dispatch(receiveLatestContracts(json));
      dispatch(handleLatestContractsError(false));
    })
    .catch(() => {
      dispatch(handleLatestContractsError(true));
    });
  };
}

export function handleLatestContractsError(bool) {
  return {
    type: types.HANDLE_LATEST_CONTRACTS_ERROR,
    latestContractsError: bool
  };
}

export function latestContractsURL(params) {
  let url = `${ORIGINATIONS_APP_BASE_URL()}applications`;
  return generateURL(url, params);
}
